import PropTypes from 'prop-types';
import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  showMoreBtn: {
    cursor: 'pointer',
    color: theme.palette.primary.main,
    marginLeft: 'auto',
    paddingTop: 4,
  },
  testWithButton: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
}));

const Truncate = ({ text, maxCellWidth, withShowBtn, alwaysTooltip }) => {
  const classes = useStyles();
  const [truncateText, setTruncateText] = React.useState(true);

  const handleClick = () => {
    setTruncateText(!truncateText);
  };

  return (
    <>
      {text.length > maxCellWidth || alwaysTooltip ? (
        <>
          <Tooltip
            placement='top'
            interactive
            title={
              withShowBtn ? '' : <Typography variant='body1'>{text}</Typography>
            }
          >
            <span className={withShowBtn ? classes.testWithButton : ''}>
              {truncateText ? (
                <span>{`${text.slice(0, maxCellWidth - 3)}...`}</span>
              ) : (
                <span>{text}</span>
              )}
              {withShowBtn && (
                <span onClick={handleClick} className={classes.showMoreBtn}>
                  {truncateText ? 'Rozwiń' : 'Zwiń'}
                </span>
              )}
            </span>
          </Tooltip>
        </>
      ) : (
        <span>{text}</span>
      )}
    </>
  );
};

Truncate.propTypes = {
  text: PropTypes.string.isRequired,
  maxCellWidth: PropTypes.number,
  withShowBtn: PropTypes.bool,
  alwaysTooltip: PropTypes.bool,
};

Truncate.defaultProps = {
  maxCellWidth: 130,
  withShowBtn: true,
  alwaysTooltip: false,
};
export default Truncate;
